import { render, staticRenderFns } from "./EqifyPage.vue?vue&type=template&id=76a4776a&scoped=true"
import script from "./EqifyPage.vue?vue&type=script&lang=ts"
export * from "./EqifyPage.vue?vue&type=script&lang=ts"
import style0 from "./EqifyPage.vue?vue&type=style&index=0&id=76a4776a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a4776a",
  null
  
)

export default component.exports